import { render, staticRenderFns } from "./PlatformsForm.vue?vue&type=template&id=401f6716&"
import script from "./PlatformsForm.vue?vue&type=script&lang=ts&"
export * from "./PlatformsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports